import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatBreadcrumbLabel'
})
export class FormatBreadcrumbLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Split by space, capitalize the first letter of each word, and join without spaces
    return value
      .split(' ')
      .map((word, index) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }
}
